let uuid = 0

// This mixins is an analog of composable useId() https://nuxt.com/docs/api/composables/use-id
// A user friendly unique identificator

export default {
    data() {
        return {
            idStatic: uuid
        }
    },
    beforeCreate() {
        this.inputId = uuid.toString()
        uuid += 1
    },
}